module.exports = __webpack_public_path__ + "img/img_ch_small.fe0e54c9.png";